// extracted by mini-css-extract-plugin
module.exports = {"navLink":"SideNav_navLink__46Vrt","navLinkActive":"SideNav_navLinkActive__QUoDN"};